// extracted by mini-css-extract-plugin
export var pillWrapper = "_qk-0";
export var showOverflow = "_qk-1";